import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { IConstructionSiteDisciplineLibraryRequest } from 'Data/interfaces/Obra/IDisciplineLibraries';
import { IDiscipline } from 'Data/interfaces/Obra/IObraData';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';

export const useQueryImportDisciplineLibrary = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IConstructionSiteDisciplineLibraryRequest) => {
      return ObrasApiV2.importDisciplineLibrary(variables);
    },
    onSuccess: async (data, variables) => {
      await queryClient.cancelQueries({
        queryKey: [OBRA_QUERY_KEY, variables.constructionSiteId],
      });

      const disciplines: IDiscipline[] = data.data.data ?? [];

      queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY], (old) => {
        return old?.map((obra) => (
          obra.ConstructionSiteId === variables.constructionSiteId
            ? { ...obra, Disciplines: disciplines }
            : obra
        ));
      });
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, variables.constructionSiteId],
        (old) => (old ? { ...old, Disciplines: disciplines } : old),
      );

      toastHandler.showSuccess('Biblioteca importada com sucesso!');
    },
    onError: (error: any) => {
      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao importar Biblioteca!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    importDisciplineLibrary: mutate,
    isLoading: isPending,
  };
};
